import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    controls: {
        padding: theme.spacing(2, 0),
    },
}));
